module.exports = __webpack_public_path__ + "img/resultadoBanner.jpg";